import { useTranslation } from 'react-i18next';
import type { AlbumFormat } from '../../types';

interface Props {
  formats: AlbumFormat[];
  value: string;
  disabled: boolean;
  onChange: (format: string) => void;
}

const BOX = 28;

/** ADR-0049: the album's size and orientation. Every page keeps its content; only the layout around it changes. */
export default function AlbumFormatPicker({ formats, value, disabled, onChange }: Props) {
  const { t } = useTranslation();
  const largest = Math.max(...formats.flatMap(f => [f.width, f.height]));
  return (
    <div className="grid grid-cols-3 gap-2" role="radiogroup" aria-label={t('album.format.title')}>
      {formats.map(f => {
        const k = BOX / largest;
        return (
          <button
            key={f.id}
            role="radio"
            aria-checked={value === f.id}
            disabled={disabled}
            onClick={() => onChange(f.id)}
            className={`flex flex-col items-center gap-1 rounded-lg py-2 cursor-pointer disabled:opacity-50 ${
              value === f.id ? 'ring-2 ring-teal-500' : 'ring-1 ring-slate-200 dark:ring-slate-700 hover:ring-teal-300'
            }`}
          >
            <span className="flex items-end justify-center" style={{ height: BOX }}>
              <span className="block rounded-[2px] bg-slate-300 dark:bg-slate-600" style={{ width: f.width * k, height: f.height * k }} />
            </span>
            <span className="text-[10px] text-slate-600 dark:text-slate-300">{t(`album.format.${f.id}`, { defaultValue: f.id })}</span>
          </button>
        );
      })}
    </div>
  );
}
